import GameBoard from './GameBoard';
import SequenceProgress from './SequenceProgress';
import type { TileLayout } from '@/pages/home/gameConfig';

interface GameScreenProps {
  span: number;
  layout: TileLayout;
  showingIndex: number;
  isShowing: boolean;
  showingStep: number;
  onTilePress: (index: number) => void;
  isInputEnabled: boolean;
  userSequence: number[];
  message: string;
}

export default function GameScreen({
  span,
  layout,
  showingIndex,
  isShowing,
  showingStep,
  onTilePress,
  isInputEnabled,
  userSequence,
  message,
}: GameScreenProps) {
  const guidanceText = isShowing
    ? '불이 켜지는 위치를 기억해주세요'
    : isInputEnabled
      ? '이제 같은 순서대로 눌러주세요'
      : message;

  return (
    <div className="flex flex-col h-full px-4 pt-[var(--screen-pt)] pb-[var(--screen-pb)] bg-white animate-fade-in-up">
      {/* 단계 안내 문구 - 화면 높이에 따라 반응형 축소 */}
      <div className="h-[var(--guidance-height)] shrink-0 flex items-center justify-center px-2">
        <p className="text-lg font-bold text-foreground-900 text-center leading-snug">
          {guidanceText}
        </p>
      </div>

      {/* 게임 영역 + 순서 UI */}
      <div className="flex-1 min-h-0 flex flex-col items-center">
        {/* 게임판 - 화면 높이에 따라 반응형 축소 */}
        <div className="w-full max-w-[360px] flex-1 min-h-0">
          <GameBoard
            layout={layout}
            showingIndex={showingIndex}
            isShowing={isShowing}
            showingStep={showingStep}
            onTilePress={onTilePress}
            isInputEnabled={isInputEnabled}
            userSequence={userSequence}
          />
        </div>

        {/* 순서 UI - 게임판 하단 별도 고정 영역 */}
        <div className="w-full max-w-[360px] h-[var(--sequence-height)] shrink-0 mt-[var(--sequence-mt)] flex items-center justify-end px-2">
          <SequenceProgress
            length={span}
            isShowing={isShowing}
            showingStep={showingStep}
            userSequence={userSequence}
            isInputEnabled={isInputEnabled}
          />
        </div>
      </div>
    </div>
  );
}